import './App.css'
import React from 'react'
import Time from './Time'

const App: React.FC = () => <Time />

export default App
